import { render, staticRenderFns } from "./wxbloodpressure.vue?vue&type=template&id=9953cd56&scoped=true&"
import script from "./wxbloodpressure.vue?vue&type=script&lang=js&"
export * from "./wxbloodpressure.vue?vue&type=script&lang=js&"
import style0 from "./wxbloodpressure.vue?vue&type=style&index=0&id=9953cd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9953cd56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9953cd56')) {
      api.createRecord('9953cd56', component.options)
    } else {
      api.reload('9953cd56', component.options)
    }
    module.hot.accept("./wxbloodpressure.vue?vue&type=template&id=9953cd56&scoped=true&", function () {
      api.rerender('9953cd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxbloodpressure.vue"
export default component.exports